import React from 'react';
import './styles.css';
import LinkBuilder from '../../helpers/link-builder';
import LinkButton from '../LinkButton';

const FileLinkWithLock = props => {
  const { data, ignoreLock } = props;
  const {
    FileID,
    FileName,
    Extension,
    Unlocked,
    UnlockedMessage,
    LockedMessage,
  } = data;

  const link = LinkBuilder.getPreparatoryFileLink(FileID, Extension);
  const locked = !(Unlocked === 'Yes' || ignoreLock);
  const lockedMsg = LockedMessage ? LockedMessage : 'Locked';
  const unlockedMsg = UnlockedMessage ? UnlockedMessage : 'Unlocked';
  const status = locked ? lockedMsg : unlockedMsg;
  const filename = `${FileName}.${Extension}`;
  const target = Extension === 'pdf' ? '_blank' : null;

  const item = locked ? (
    <span className="file-link-with-lock__link">{filename}</span>
  ) : (
    <LinkButton
      className="file-link-with-lock__link"
      text={filename}
      link={link}
      target={target}
      btnFontWeight="400"
      btnFontFamily="Noto Sans"
    />
  );

  return (
    <div className="file-link-with-lock">
      <div className="file-link-with-lock__file">{item}</div>

      <div className="file-link-with-lock__status">{status}</div>
    </div>
  );
};

export default FileLinkWithLock;
